import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { fetchAdvertorials } from "@/lib/api";
import { AdSlot } from "@/components/AdSlot";

export default function Advertorials() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchAdvertorials()
      .then(setItems)
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="max-w-[1400px] mx-auto px-5 lg:px-10 py-16">
      <div className="border-b border-white/10 pb-10">
        <span className="font-mono text-xs uppercase tracking-[0.3em] text-signal">Paid Partnerships</span>
        <h1 className="font-anton text-6xl md:text-8xl uppercase tracking-tight mt-3 leading-none" data-testid="advertorials-title">
          Sponsored
        </h1>
        <p className="text-muted-foreground text-lg mt-4 max-w-2xl">
          Branded stories created with the culture in mind. Want yours here?{" "}
          <Link to="/advertise" className="text-signal hover:underline">See packages &amp; advertise →</Link>
        </p>
      </div>

      {loading ? (
        <p className="font-mono text-sm text-muted-foreground mt-10">Loading…</p>
      ) : items.length === 0 ? (
        <p className="font-mono text-sm text-muted-foreground mt-10" data-testid="advertorials-empty">
          No sponsored stories yet. Create one in the NS Studio.
        </p>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-10">
          {items.map((a, i) => (
            <Link
              key={a.slug}
              to={`/advertorial/${a.slug}`}
              data-testid={`advertorial-card-${a.slug}`}
              className="group block border border-white/10 bg-card hover:border-signal transition-colors animate-rise"
              style={{ animationDelay: `${i * 60}ms` }}
            >
              <div className="relative overflow-hidden aspect-[4/3]">
                <img src={a.image} alt={a.title} className="img-treatment w-full h-full object-cover" loading="lazy" />
                <span className="absolute top-3 left-3 font-mono text-[10px] uppercase tracking-widest bg-white text-black px-2 py-1">
                  Sponsored
                </span>
              </div>
              <div className="p-5">
                <span className="font-mono text-[10px] uppercase tracking-widest text-signal">{a.brand}</span>
                <h3 className="font-display text-lg font-semibold tracking-tight leading-[1.05] mt-2 group-hover:text-signal transition-colors">
                  {a.title}
                </h3>
                <div className="flex items-center justify-between mt-4">
                  <span className="font-mono text-[11px] uppercase tracking-widest text-muted-foreground">
                    Paid Partnership
                  </span>
                  <ArrowUpRight className="w-4 h-4 text-muted-foreground group-hover:text-signal transition-colors" />
                </div>
              </div>
            </Link>
          ))}
          <AdSlot variant="infeed" slot={process.env.REACT_APP_ADSENSE_SLOT_SPONSORED} className="sm:col-span-2 lg:col-span-1" />
        </div>
      )}
    </div>
  );
}
